import { useState } from "react"
import classes from "../../stats/Statistics.module.css"
import { Interval } from "../../navigation/tabs/Tabs";
import {subDays} from "date-fns"
import { Area } from "../../navigation/tree/Area";
import { Layout, Layouts, Responsive, WidthProvider } from "react-grid-layout";
import WithTreeTab from "../WithTreeTab";
import { Graph, GraphType } from "../../graph/Graph";
import { MediaspotsInfo } from "../../stats/maintenance/MediaspotInfo";
import { RouterInfo } from "../../stats/maintenance/RouterInfo";
import { getRangeEndDate, getRangeStartDate } from "../../helpers/Storage";

const Maintenance = () => {

    const endDate = getRangeEndDate() === null ? Date.now() : getRangeEndDate() as number
    const startDate = getRangeStartDate() === null ? subDays(endDate, 1) : new Date(getRangeStartDate() as number)
    startDate.setHours(0,0,0,0);

    const ResponsiveReactGridLayout = WidthProvider(Responsive);
    const [layouts, setLayouts] = useState<Layouts>({})

    // const [selectedTab, setSelectedTab] = useState<TabItem>(items[0])
    const [startPeriodTimestamp, setStartPeriodTimestamp] = useState<number>(startDate.getTime())
    const [endPeriodTimestamp, setEndPeriodTimestamp] = useState<number>(endDate)

    const [_, setSelectedNodeId] = useState<string|undefined>(undefined)
    const [selectedNodePath, setSelectedNodePath] = useState<string|undefined>(undefined)
    const [selectedArea, setSelectedArea] = useState<Area|undefined>(undefined)

    const [interval, setInterval] = useState<Interval>(Interval.DAY)

    const onSelectArea = (area: Area, nodeId: string, nodePath: string) => {
        console.log("select area", area)
        setSelectedNodeId(nodeId)
        setSelectedArea(area)
        setSelectedNodePath(nodePath)
    }

    console.log(selectedArea)
    return (
        <WithTreeTab
            items={[]}
            onPeriodChanged={(startDateTimestamp, endDateTimestamp) => {
                setStartPeriodTimestamp(new Date(startDateTimestamp).getTime())
                setEndPeriodTimestamp(new Date(endDateTimestamp).getTime())}}
            onIntervalChanged={(newInterval) => setInterval(newInterval)}
            onSelectArea={onSelectArea}>


                {selectedNodePath !== undefined && selectedArea !== undefined ? (
                    <ResponsiveReactGridLayout
                        rowHeight={100}
                        cols={{ lg: 12, md: 12, sm: 6, xs: 4, xxs: 2 }}
                        layouts={layouts}
                        onLayoutChange={(_currentLayout: Layout[], allLayouts: Layouts) => {
                            // Check to prevent infinite refresh
                            if(JSON.stringify(allLayouts) !== JSON.stringify(layouts)){
                                setLayouts(allLayouts)
                            }
                        }}>

                            {
                                (selectedArea?.mediaspot === undefined && (selectedArea.router === undefined || selectedArea.router?.length === 0 ))
                                
                                ? <div key="select_area_label" data-grid={{ w: 6, h: 3, x: 0, y: 0, static: true }}>
                                    <label>Veuillez sélectionner une zone contenant des appareils</label>
                                    </div>
                                : <div key="empty_select_area_label" data-grid={{ w: 0, h: 0, x: 0, y: 0, static: true }}/>
                            }

                        {
                            selectedArea?.mediaspot !== undefined ? 
            
                                <div className={classes.ChartContainer} key={"infos_mediaspot"} data-grid={{ w: 6, h: 3, x: 0, y: 0, static: true }}>
                                    <label>Informations mediaspots</label>
                                    <div className={classes.ChartTitleSeparator}/>
                                    <MediaspotsInfo mediaspot={selectedArea.mediaspot} />
                                </div>
                                : <div key="empty_1"/>
                        }

                        {
                            selectedArea?.mediaspot !== undefined ? 
                                <div className={classes.ChartContainer} key={"infos_modem_temperature"} data-grid={{ w: 6, h: 3, x: 6, y: 0, static: true }}>
                                    <label>Évolution de la température du modem</label>
                                    <div className={classes.ChartTitleSeparator}/>
                                    <div className={classes.ChartGraphContainer}>            
                                        <Graph
                                            preventUpdateAnimations={false}
                                            graphType={GraphType.TEMPERATURE_EVOLUTION}
                                            startDatePeriodTimestamp={startPeriodTimestamp}
                                            endDatePeriodTimestamp={endPeriodTimestamp}
                                            interval={interval}
                                            mediaspotSerial={selectedArea.mediaspot.serial}
                                            nodePath={selectedNodePath}/>
                                    </div>
                                </div>: <div key="empty_4"/>
                        }               

                        {
                            selectedArea?.router !== undefined && selectedArea?.router.length > 0 ? 
            
                                <div className={classes.ChartContainer} key={"infos_router"} data-grid={{ w: 6, h: 4, x: 0, y: 3, static: true }}>
                                    <label>Informations routeur</label>
                                    <div className={classes.ChartTitleSeparator}/>
                                    <RouterInfo router={selectedArea.router[0]} />
                                </div>
                                : <div key="empty_router"/>
                        }

                      
                    </ResponsiveReactGridLayout>)
                : <div key="empty_0"/> }
        </WithTreeTab>    
    )
}

export default Maintenance